import React from 'react';
import {ErrorMessage, Field} from "formik";

const Question = props => {
	const name = 'question_' + props.data.key;
	const dashedClassName = getErrorClassName( props );
	return <div className={dashedClassName}>
		<Field as="select" name={name}>
			{['Opinar', 0, 1, 2, 3, 4, 5, 6].map( value => <option key={value} value={value}>{value}</option> )}
		</Field>
		<label htmlFor="{name}">{props.data.value}</label>
		<ErrorMessage name={name} component="div"/>
	</div>;

	function getErrorClassName( props )
	{
		if ( props.errors[ name ] && props.errors[ name ].props && props.errors[ name ].props.children ) {
			if ( props.errors[ name ].props.children.indexOf( 'nota' ) !== -1 ) {
				return 'question error-dashed-warning';
			} else
				if ( props.errors[ name ].props.children.indexOf( 'valor' ) !== -1 ) {
					return 'question error-dashed';
				}
		} else {
			return 'question';
		}
	}
};

export default Question;